import { gql } from '@apollo/client';
import {
    COMPLETED_TASK_FRAGMENT,
    TASK_FORM_ITEM_FRAGMENT,
} from '../../../../../common/form/task-form/model/task-items.gql';

export const GET_VOLUNTEER_ADD_TASKS_SECTION_TASK = gql`
  query GetVolunteerAddTasksSectionTask(
    $taskId: String!
    $userId: String!
    $profileId: String!
  ) {
    vm {
      profile(profileId: $profileId) {
        userId
        preferredName
        firstName
        lastName
        contactNumber
        dateOfBirth
        programs {
          name
        }
        completedTasks {
          completedTaskId
          task {
            taskId
          }
        }
      }
      application(userId: $userId) {
        relevantTasks {
          cake {
            cakeType
          }
        }
      }
      task(taskId: $taskId) {
        taskId
        title
        description
        isPaymentTask
        stripeConfig {
          stripeProductId
          stripeProductType
          autoCompleteOnPayment
        }
        cake {
          title
        }
        taskItems {
          ...TaskFormItem
        }
        order
      }
    }
  }

  ${COMPLETED_TASK_FRAGMENT}
  ${TASK_FORM_ITEM_FRAGMENT}
`;

export const GET_COMPLETED_TASKS_FOR_CROSS_TASK_LOOKUP = gql`
  query GetCompletedTasksForCrossTaskLookup($userId: String!) {
    vm {
      profile(userId: $userId) {
        completedTasks {
          completedTaskId
          task {
            taskId
            title
          }
          taskFieldValues {
            taskFieldValueId
            field {
              taskFieldId
            }
            ... on VOLUNTEER_DropdownTaskFieldValueType {
              dropdownTaskFieldOption {
                dropdownFieldOptionId
              }
            }
            ... on VOLUNTEER_MultipleChoiceTaskFieldValueType {
              multipleChoiceTaskFieldOption {
                multipleChoiceFieldOptionId
              }
            }
            ... on VOLUNTEER_CheckboxTaskFieldValueType {
              checkboxTaskFieldOptions {
                checkboxFieldOptionId
              }
            }
            ... on VOLUNTEER_QuizTaskFieldValueType {
              quizTaskFieldOption {
                quizTaskFieldOptionId
              }
            }
          }
        }
      }
      # Also get all tasks that could be source tasks
      tasks {
        taskId
        title
      }
    }
  }
`;
